import { render, staticRenderFns } from "./DesignationTypesSelect.vue?vue&type=template&id=0fbdf93d&scoped=true&lang=pug"
import script from "./DesignationTypesSelect.vue?vue&type=script&lang=js"
export * from "./DesignationTypesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbdf93d",
  null
  
)

export default component.exports